import React from 'react'
import './portfolio.css'
import IMG1 from '../../assets/portfolio1.png'
import IMG2 from '../../assets/portfolio2.png'
import IMG3 from '../../assets/portfolio3.png'
import IMG4 from '../../assets/portfolio4.png'
import IMG5 from '../../assets/portfolio5.png'
// import IMG6 from '../../assets/portfolio6.jpg'

const data = [
  {
    id: 1,
    image: IMG1,
    title: 'Weather Application',
    description: 'A weather application was built using React.js, styled with Tailwind CSS and Sass. The application fetches real-time weather data from the OpenWeatherMap API, providing users with up-to-date weather information for their location.',
    github: 'https://github.com/cloby99/weather-app',
    demo: 'https://cloby99.github.io/weather-app/'
  },
  {
    id: 2,
    image: IMG2,
    title: 'LinkedIn Clone',
    description: 'Built a LinkedIn clone using React and Redux as part of my learning journey in state management. This project also incorporated Firebase authentication, allowing users to securely sign in and interact with the platform , and utilized Firebase to store user posts.',
    github: 'https://github.com/cloby99/linkedin-clone',
    demo: 'https://cloby99.github.io/linkedin-clone-update/'
  },
  {
    id: 4,
    image: IMG4,
    title: 'To Do App',
    description: 'TaskWhiz is a user-friendly to-do application crafted with React and Vite, designed to streamline task management. Leveraging local storage, TaskWhiz offers a convenient and efficient way for users to save and organize their tasks.',
    github: 'https://github.com/cloby99/todo-app',
    demo: 'https://task-whiz.web.app/'
  },
  {
    id: 5,
    image: IMG5,
    title: 'Pawpals Care',
    description: 'Pawpals Care is a heartfelt initiative aimed at assisting stray animals in finding loving homes. Our project\'s initial phase has seen the creation of a captivating landing page using React. We\'re currently in the process of developing a mobile application.',
    github: 'https://github.com/cloby99/PawPalsCare-LandingPage',
    demo: 'https://pawpals-care.web.app/'
  },
  // {
  //   id: 3,
  //   image: IMG3,
  //   title: 'Crypto Trading Platform',
  //   description: 'Introducing a dynamic Crypto Trading Platform meticulously crafted in C++. This platform is engineered with a keen focus on three essential pillars: efficient order matching, real-time analytics, and secure wallet management.',
  //   github: 'https://github.com/cloby7',
  //   demo: ''
  // },
  // {
  //   id: 6,
  //   image: IMG6,
  //   title: 'Project 6',
  //   github: 'https://github.com/cloby7',
  //   demo: 'https://medium.com/@anudelay99'
  // }

]



const Portfolio = () => {
  return (
    <section id="portfolio">
      <h5>My Recent Work</h5>
      <h2>Learning Projects</h2>

      <div className="container portfolio__container">
        {
          data.map(({id, image, title, description ,github, demo}) =>{
            return(
              <article key={id} className="portfolio__item">
                  <h3>{title}</h3>
                  <div className="portfolio__item-image">
                    <img src={image} alt={title} />
                  </div>
                  <small>{description}</small>
                  <div className="portfolio__item-cta">
                    <a href={github} className='btn' target='_blank'>Github</a>
                    {demo && <a href={demo} className='btn btn-primary' target='_blank'>Demo</a>}
                  </div>
              </article>
          
            )
          })
        }
      </div>
    </section>
  )
}

export default Portfolio